module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "calibre2",
    attrs: {
      "id": "pgepubid00004"
    }
  }, [_vm._v("PREFACE.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre5"
  }, [_vm._v("Feeling anxious to preserve for future reference an account of the part which the Negro took in suppressing the Slaveholders’ Rebellion, I have been induced to write this work. In doing so, it occurred to me that a sketch of the condition of the race previous to the commencement of the war would not be uninteresting to the reader.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre5"
  }, [_vm._v("For the information concerning the services which the blacks rendered to the Government in the Revolutionary War, I am indebted to the late George Livermore, Esq., whose “Historical Research” is the ablest work ever published on the early history of the negroes of this country.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre5"
  }, [_vm._v("In collecting facts connected with the Rebellion, I have availed myself of the most reliable information that could be obtained from newspaper correspondents, as well as from those who were on the battle-field. To officers and privates of several of the colored regiments I am under many obligations for detailed accounts of engagements.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre5"
  }, [_vm._v("No doubt, errors in fact and in judgment will be discovered, which I shall be ready to acknowledge, and correct in subsequent editions. The work might have been swelled to double its present size; but I did not feel bound to introduce an account of every little skirmish in which colored men were engaged.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre5"
  }, [_vm._v("I waited patiently, before beginning this work, with the hope that some one more competent would take the subject in hand; but, up to the present, it has not been done, although many books have been written upon the Rebellion.")]), _vm._v(" "), _c('h3', {
    staticClass: "calibre8 sigil_not_in_toc",
    attrs: {
      "id": "pgepubid00005"
    }
  }, [_vm._v("WILLIAM WELLS BROWN.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre5"
  }, [_vm._v("Cambridgeport, Mass., Jan. 1, 1867.")]), _vm._v(" "), _c('div', {
    staticClass: "calibre9",
    attrs: {
      "id": "calibre_pb_2"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a637da12","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Section0002.vue
// module id = 60
// module chunks = 0